export class ItemTemplateController implements angular.IOnInit {
  static $inject = [];

  public tracker: string;
  public price: number;
  public quantity: number;
  public portfolioValue: number;
  public modelPercentage: number;
  public geography: string;
  public sector: string;

  public selectedGeography: string = "Geography";
  public geographyList: string[] = ["USA", "MU", "RSA", "UK"];

  /** @ngInject */
  constructor() {
    var that = this;

    //that.selectedGeography = localStorage.getItem('itemGeography');
  }

  $onInit() {
    var that = this;
  }

  public onGeographyChange() {
    //localStorage.setItem('itemGeography', this.selectedGeography);
    // console.log(this.selectedGeography);
  }
}

export const itemTemplate: angular.IComponentOptions = {
  template: require("./itemtemplate.html"),
  controller: ItemTemplateController,
};



// WEBPACK FOOTER //
// ./src/app/cmodel/modaltemplates/itemtemplate.ts